import { useQueryClient } from '@tanstack/react-query'
import { useBusinessContext } from '@root/context'

export const useInvalidateInvoiceQueries = (invoiceId: number) => {
  const { slug } = useBusinessContext()
  const queryClient = useQueryClient()

  return () => {
    queryClient.invalidateQueries({ queryKey: [slug, 'invoices'] })
    queryClient.invalidateQueries({ queryKey: [slug, 'invoices', invoiceId] })
    queryClient.invalidateQueries({ queryKey: [slug, 'combined_invoices'] })
  }
}
